export default __webpack_public_path__ + "static/media/auto.d72a66b6.png";